import React from "react";
import { FormSelect as Select } from "@jsq/ds/forms";
import { capitalizeEachWord } from "../../../utils/text_utils";
import { UsStates } from "../constants";

type Props = {
  name: string;
  isFull?: boolean;
  placeholder?: string;
  label?: string;
};

export const StateSelectDropdown: React.FunctionComponent<Props> = ({
  name,
  isFull = true,
  placeholder = "Select a state",
  label = undefined,
}) => {
  return (
    <Select
      name={name}
      full={isFull}
      placeholder={placeholder}
      data-cy={name}
      data-testid={name}
      label={label}
    >
      <Select.Section>
        {UsStates.map((state) => (
          <Select.Option key={state.code} value={state.code.toUpperCase()}>
            {capitalizeEachWord(state.name)}
          </Select.Option>
        ))}
      </Select.Section>
    </Select>
  );
};
